var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveUpIkonElOvrigt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "362.52 189 258.12 395.77 355.8 395.77 256.38 583 516.52 319.47 397.16 319.47 466.98 189 362.52 189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveUpIkonElOvrigt);
export default __webpack_public_path__ + "static/media/SaveUp_Ikon-el-ovrigt.865eea64c7f1589c29adcf93c42bd27e.svg";
export { ForwardRef as ReactComponent };